<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入活动标题' }] }]"
            name="title"
            placeholder="请输入活动标题"
          />
        </a-form-item>
        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            name="tag"
            placeholder="请输入活动标签"
            v-decorator="['tag', { rules: [{ required: true, message: '请输入活动标签' }] }]"
          />
        </a-form-item>
        <a-form-item label="活动日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-range-picker
            showTime
            name="date"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始日期', '结束日期']"
            v-decorator="['date', { rules: [{ required: true, message: '请选择显示日期' }] }]"
          />
        </a-form-item>
        <a-form-item label="关联活动" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            option-filter-prop="children"
            placeholder="请选择关联活动"
            name="activity_id"
            v-decorator="['activity_id']"
          >
            <a-select-option v-for="item in ActList" :key="item.id" :value="item.id">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在生效，默认生效">
          <a-switch
            checked-children="生效"
            un-checked-children="无效"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-row>
          <a-col :sm="24" :md="12" :lg="8">
            <h3>课程</h3>
            <a-spin :spinning="coursesLoad">
              <a-form-item v-for="(item, index) in coursesList" :key="index" :label="item.title">
                <a-input-number
                  :style="{ borderColor: item.discount ? 'green' : '' }"
                  v-decorator="[
                    `course_price[${item.id}]`,
                    {
                      validateTrigger: ['change', 'blur'],
                      initialValue: item.discount ? item.discount.price / 100 : item.price / 100,
                      rules: [
                        {
                          required: true,
                          message: '请输入活动价格'
                        }
                      ]
                    }
                  ]"
                  placeholder="活动价格"
                />
              </a-form-item>
            </a-spin>
          </a-col>
          <a-col :sm="24" :md="12" :lg="8">
            <h3>证书</h3>
            <a-spin :spinning="crtsLoad">
              <a-form-item v-for="(item, index) in crtsList" :key="index" :label="item.title">
                <a-input-number
                  :style="{ borderColor: item.discount ? 'green' : '' }"
                  v-decorator="[
                    `crt_price[${item.id}]`,
                    {
                      validateTrigger: ['change', 'blur'],
                      initialValue: item.discount ? item.discount.price / 100 : item.price / 100,
                      rules: [
                        {
                          required: true,
                          message: '请输入活动价格'
                        }
                      ]
                    }
                  ]"
                  placeholder="活动价格"
                />
              </a-form-item>
            </a-spin>
          </a-col>
          <a-col :sm="24" :md="12" :lg="8">
            <h3>套购</h3>
            <a-spin :spinning="packsLoad">
              <a-form-item v-for="(item, index) in packsList" :key="index" :label="item.title">
                <a-input-number
                  :style="{ borderColor: item.discount ? 'green' : '' }"
                  v-decorator="[
                    `pack_price[${item.id}]`,
                    {
                      validateTrigger: ['change', 'blur'],
                      initialValue: item.discount ? item.discount.price / 100 : item.price / 100,
                      rules: [
                        {
                          required: true,
                          message: '请输入活动价格'
                        }
                      ]
                    }
                  ]"
                  placeholder="活动价格"
                />
              </a-form-item>
            </a-spin>
          </a-col>
        </a-row>

        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form, select } from '@/mixins'
import { GoBack } from '@/components'
const apiList = {
    getInfo: '/activities/discounts/',
    ActList: '/activities/select',
    coursesList: '/courses/select',
    crtsList: '/certificates/select',
    packsList: '/courses/packs/select',
    create: '/activities/discounts/create',
    update: '/activities/discounts/'
}
const fields = ['tag', 'title', 'activity_id', 'date', 'state']

export default {
    name: 'DiscountForm',
    mixins: [form, select],
    components: {
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            coursesLoad: false, // 课程下拉加载
            coursesList: null, // 课程下拉数据
            packsList: null, // 套购下拉列表
            packsLoad: false, // 套购下拉加载
            crtsLoad: false, // 证书下拉加载
            crtsList: null, // 证书下拉列表
            ActLoad: false,
            ActList: {} // 活动列表
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.state = values.state === 1
                values.date = [that.moment(values.start_time * 1000), that.moment(values.expire_time * 1000)]
            }) // 获取编辑信息
        }
        that.getSelectLists({
            url: apiList.ActList,
            type: 'ActList',
            load: 'ActLoad'
        })
        that.getSelectLists({
            url: apiList.crtsList + '/' + that.$route.params.id,
            type: 'crtsList',
            load: 'crtsLoad'
        })
        that.getSelectLists({
            url: apiList.packsList + '/' + that.$route.params.id,
            type: 'packsList',
            load: 'packsLoad'
        })
        that.getSelectLists({
            url: apiList.coursesList + '/' + that.$route.params.id,
            type: 'coursesList',
            load: 'coursesLoad'
        })
    },
    methods: {
        setFormData (values) {
            values.start_time = this.moment(values.date[0]).format('YYYY-MM-DD HH:mm:ss')
            values.expire_time = this.moment(values.date[1]).format('YYYY-MM-DD HH:mm:ss')
            values.state = values.state ? 1 : 2
        }
    }
}
</script>
